import { render, staticRenderFns } from "./OrganizationInviteUserModel.vue?vue&type=template&id=0457eb0c&scoped=true&"
import script from "./OrganizationInviteUserModel.vue?vue&type=script&lang=js&"
export * from "./OrganizationInviteUserModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457eb0c",
  null
  
)

export default component.exports